import { makeStyles } from "tss-react/mui";

export const useConfirmationDialogActivatorStyles = makeStyles()((theme) => ({}));
